import React, { useState } from 'react';
import { useTheme } from '../../theme/ThemeContext';

export default function EmailInput({ value, onChange, error, disabled }) {
  const { theme } = useTheme();
  const isDark = theme.auth.containerBg === '#111827';
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div style={{ marginBottom: 12 }}>
      <label style={{ display: 'block', marginBottom: 4, fontSize: 12, fontWeight: 600, color: theme.auth.labelColor, letterSpacing: '0.2px' }}>
        Email Address
      </label>
      <input
        type="email"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        disabled={disabled}
        placeholder="your.email@example.com"
        style={{
          width: '100%',
          padding: '10px 12px',
          fontSize: 14,
          fontWeight: 500,
          border: `2px solid ${error ? (isDark ? 'rgba(220, 38, 38, 0.5)' : 'rgba(192, 57, 43, 0.35)') : isFocused ? (isDark ? 'rgba(13, 148, 136, 0.6)' : 'rgba(15, 118, 110, 0.5)') : (isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)')}`,
          borderRadius: 10,
          background: isDark ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.02)',
          color: theme.auth.inputText,
          boxSizing: 'border-box',
          opacity: disabled ? 0.6 : 1,
          cursor: disabled ? 'not-allowed' : 'text',
          transition: 'all 0.2s ease',
          outline: 'none',
          boxShadow: isFocused ? (isDark ? 'inset 0 1px 3px rgba(13, 148, 136, 0.1)' : 'inset 0 1px 3px rgba(15, 118, 110, 0.08)') : 'none'
        }}
      />
      {error ? (
        <div style={{ marginTop: 4, fontSize: 12, color: isDark ? '#FF8A80' : '#8B3A2F', fontWeight: 500 }}>{error}</div>
      ) : null}
    </div>
  );
}
